import {createAsyncThunk} from '@reduxjs/toolkit';
import targetPlatformApi from 'common/src/modules/targetPlatform/targetPlatform.api';
import videoSettingsApi from 'common/src/modules/videoSettings/videoSettings.api';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';

export const initializeSlimTargetPlatforms = createAsyncThunk(
  `${BreadcrumbName.TargetPlatforms}/initializeSlim`,
  async (_, {rejectWithValue}) => {
    try {
      const [platforms, videoSettings] = await Promise.all([
        targetPlatformApi.fetchTargetPlatforms(),
        videoSettingsApi.fetchVideoSettings(),
      ]);

      return {platforms, videoSettings};
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);
